import { useContext } from 'react';
import UserContext from 'common/context/UserContext';

export const useUser = () => {
  const context = useContext(UserContext);
  return context;
};
